var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showDiscount
    ? _c("emd-text-content", { attrs: { title: _vm.$t("discount") } }, [
        _vm.data.discountPercentage
          ? _c("span", [
              _vm._v(" " + _vm._s(_vm.data.discountPercentage + "%") + " "),
            ])
          : _c("span", [_vm._v(" " + _vm._s(_vm.data.discount) + " ")]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }